import React from "react";
import styles from "./input-text.module.scss";

interface IInputTextProps {
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputText = ({ value, onChange }: IInputTextProps) => {
  return (
    <div className={styles.container}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        className={styles.input}
      />
    </div>
  );
};

export default InputText;
